import scrollDir from 'scrolldir';

scrollDir({ dir: 'up' });
